import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SupplierItem } from '../models/supplier-control.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  public postInsertItemSupplier(item: SupplierItem): Observable<SupplierItem> {
    return this.http.post<SupplierItem>(
      `${this.apiServerUrl}/api/v1/insertItemSupplier`,
      item,
      { withCredentials: true }
    );
  }

  public updateInsertItemSupplier(
    item: SupplierItem,
    id: Number
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/updateItemSupplier/${id}`,
      item,
      { withCredentials: true }
    );
  }

  public deleteItemSupplier(id: number): Observable<String> {
    return this.http.get<String>(
      `${this.apiServerUrl}/api/v1/deleteItemSupplier/${id}`
    );
  }

  public getItemSupplier(): Observable<SupplierItem[]> {
    return this.http.get<SupplierItem[]>(
      `${this.apiServerUrl}/api/v1/getItemSupplier`
    );
  }
}
